import Tooltip from 'react-tooltip-lite';
import styled from 'styled-components';
import theme from '../../../theme';

export default styled(Tooltip)
  .attrs((props) => ({
    padding: '3px 7px',
    arrowSize: 5,
    ...props,
  }))`
  display: inline;
  
  .react-tooltip-lite {
    background: ${theme.colors.darker};
    color: ${theme.colors.white};
    font-size: ${theme.fontSizes.small};
  }
  
  .react-tooltip-lite-arrow {
    border-color: ${theme.colors.darker};
  }
`;
